import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Constants} from '@app/app.constants';
import {LocaleSettings} from 'primeng/primeng';
import * as moment from 'moment';
import {UIService} from '@app/services/ui.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CalendarComponent),
    multi: true
  }]
})
export class CalendarComponent implements OnInit, ControlValueAccessor {
  @Input() name: string;
  @Input() disabled = false;
  @Input() required = false;
  @Input() placeholder: string;
  @Input() appendTo: string;
  @Input() showIcon = true;
  @Input() showButtonBar = true;
  @Input() yearNavigator = true;
  @Input() monthNavigator = true;
  @Input() showTime = false;
  @Input() timeOnly = false;
  @Input() yearRange: string;

  @Input() fixUtcProblem = true;

  @Input() locale: LocaleSettings;
  @Input() dateFormat: any;

  @Output() outDateChange = new EventEmitter<any>();
  @Output() outOnSelect = new EventEmitter<any>();
  @Output() outOnBlur = new EventEmitter<any>();

  innerValue: Date;
  value: Date;


  _minDate: Date;
  @Input()
  set minDate(date: Date) {
    if (date && typeof date !== 'string') {
      this._minDate = date;
    }
  }

  get minDate() {
    return this._minDate;
  }

  _maxDate: Date;
  @Input()
  set maxDate(date: Date) {
    if (date && typeof date !== 'string') {
      this._maxDate = date;
    }
  }

  get maxDate() {
    return this._maxDate;
  }


  constructor(private ui: UIService) {
  }

  ngOnInit() {
    this.locale = Constants.getDateLocale(this.ui.i18n.getDefaultLang());
    this.dateFormat = 'dd/mm/yy';

    if (!this.yearRange) {
      const date = new Date();
      const year = date.getFullYear();
      this.yearRange = year - 10 + ':' + (year + 10);
    }
  }

  onModelChange: (_: any) => void = (_: any) => {
  };
  onModelTouched: () => void = () => {
  };

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: any): void {
    this.innerValue = null;
    if (value instanceof Date) {
      this.innerValue = value;
    }
    else if (value) {
      this.innerValue = new Date(value);
    }
  }


  updateModel(value: any) {
    this.innerValue = value;
    this.value = null;
    if (this.isValidDate(value)) {
      let m = moment(value);
      if (this.fixUtcProblem) {
        m = m.add(m.utcOffset(), 'm');
      }
      this.value = new Date(m.toISOString());
    }

    this.onModelChange(this.value);
    this.outDateChange.emit(this.value);
  }


  onSelect(event) {
    this.outOnSelect.emit(event);
  }

  onBlur(event) {
    this.outOnBlur.emit(event);
    this.onModelTouched();
  }

  isValidDate(d: any) {
    return !isNaN(d) && d instanceof Date;
  }
}
